import { Component } from 'react';

import Counter from '../../elements/Counter';

interface Props {
  amount: number;
  updateCartItemAmount: Function;
  vid: number | string;
  disabled?: boolean;
}

export default class CardCounter extends Component<Props> {
  handleUpdateCounter = (virtualProductID, amount) => {
    this.props.updateCartItemAmount({
      virtualProductID,
      amount,
    });
  };

  render() {
    const { amount, vid, disabled } = this.props;

    return (
      <Counter
        initialCount={amount}
        min={1}
        max={20}
        onChange={count => this.handleUpdateCounter(vid, count)}
        quantity={amount}
        disabled={disabled}
      />
    );
  }
}
